/******/ (function() { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/components/filter-flyout.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Collection filter flyout.
 *
 * Owns pending filter selections and is the ONLY place filter URLs are built.
 * Selections do not apply on change — they accumulate until Apply (design decision 1).
 *
 * This module deliberately shares no selectors with the vendor filter module in
 * assets/theme.dev.js. If this element ever ends up inside [data-collection-sidebar]
 * the vendor binds to it too and every click applies twice, so that is asserted below.
 */

// Pure: state -> URLSearchParams entries. No DOM. Unit-testable if a harness lands.
function stateToParams(state) {
  var out = [];
  state.forEach(function (values, paramName) {
    values.forEach(function (value) {
      return out.push([paramName, value]);
    });
  });
  return out;
}

// Pure: existing search string + state -> new search string.
// Preserves sort_by, q, and anything else; replaces only filter.* keys.
// In-stock-only, always — matching the legacy filter path exactly.
//
// snippets/collection-filters-sidebar.liquid:43 puts a hardcoded
// `<input type="hidden" name="filter.v.availability" value="1">` in the sidebar form, and
// the vendor rebuilds filter URLs from `new FormData(this.form)`. So every interaction on
// that path writes in-stock-only into the URL. It is a permanent default rather than a
// shopper choice, which is why the visible Availability group is hidden (filters.liquid:29)
// and skipped outright by this drawer (collection-filter-flyout.liquid:68).
//
// The drawer has to assert the same thing or it silently widens every result: "Size: S"
// comes to mean "has an S variant, stocked or not" instead of "an S I can buy". Measured at
// 124 results here against 96 on the live theme for Button-Ups & Tops at size S.
//
// ASSERTED, not merely preserved. A first interaction starts from a clean collection URL
// with no filter params at all, so there would be nothing to carry forward.
var AVAILABILITY_PARAM = 'filter.v.availability';
var AVAILABILITY_VALUE = '1';
function buildUrl(state, search) {
  var params = new URLSearchParams(search);
  _toConsumableArray(params.keys()).forEach(function (key) {
    if (key.indexOf('filter.') === 0) params.delete(key);
  });
  params.delete('page');
  // set(), not append(): the delete above already cleared any inherited copy, and set()
  // keeps this idempotent if that ever changes.
  params.set(AVAILABILITY_PARAM, AVAILABILITY_VALUE);
  stateToParams(state).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    return params.append(name, value);
  });
  var qs = params.toString();
  return qs ? "?".concat(qs) : '';
}

// Identity of one option across both data sources: its checkbox name + value.
// NUL as the separator: it cannot occur in a param name or a filter value, so
// "color" + "Blue" can never collide with some other split of the same characters.
function availabilityKey(name, value) {
  return "".concat(name, "\0").concat(value);
}

// Must match the panel/scrim transition duration in filter-flyout.scss.
var CLOSE_MS = 300;
var FilterFlyout = /*#__PURE__*/function () {
  /**
   * @param {Element|null} root     The [data-filter-flyout] element. Defaults to the first
   *                                one in the document, which is what collection.js relies on.
   * @param {Object}       options  Opaque here; kept for subclasses. SearchFilterFlyout passes
   *                                its InstantSearch bridge as `options.bridge`.
   */
  function FilterFlyout() {
    var _this = this;
    var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector('[data-filter-flyout]');
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, FilterFlyout);
    this.root = root;
    if (!this.root) return;
    this.options = options;
    if (this.root.closest('[data-collection-sidebar]')) {
      // Silent double-apply otherwise. Loud here, not a mystery bug later.
      console.error('[filter-flyout] rendered inside [data-collection-sidebar] — the vendor module will double-apply. Move the render call.');
    }
    this.trigger = this.root.querySelector('[data-ff-trigger]');
    this.panel = this.root.querySelector('[data-ff-panel]');
    this.scrim = this.root.querySelector('[data-ff-scrim]');
    this.rail = this.root.querySelector('[data-ff-rail]');
    this.chips = this.root.querySelector('[data-ff-chips]');
    this.badge = this.root.querySelector('[data-ff-badge]');
    this.applyBtn = this.root.querySelector('[data-ff-apply]');
    this.clearBtn = this.root.querySelector('[data-ff-clear]');
    this.closeBtn = this.root.querySelector('[data-ff-close]');
    this.status = this.root.querySelector('[data-ff-status]');
    this.closeTimer = null;
    this.applying = false;

    // Reparent the drawer to <body>.
    //
    // `.collection__nav` carries z-index 666 above 1025px (mixins.scss:122-127) and
    // another under `.collection--compact-mobile`. Either one opens a stacking context,
    // which would cap the panel at 666 no matter what z-index it declares — far below
    // the header band (app.css puts `#shopify-section-header` at 99999 and the
    // announcement at 999999) — so the header would paint over a "modal" drawer and stay
    // clickable through it. Any `transform` on an ancestor would additionally re-root
    // `position: fixed` onto that ancestor's box rather than the viewport.
    //
    // The trigger, badge and live region stay put; only the panel and scrim move. Every
    // element ref above was captured first, so they all survive the move — but queries
    // for panel CONTENT must go through `this.panel` from here on, never `this.root`.
    document.body.appendChild(this.scrim);
    document.body.appendChild(this.panel);
    this.state = new Map();
    this.countController = null;
    this.countTimer = null;
    this.countSeq = 0;

    // Where filter results come from. Runs BEFORE the first render() because a subclass's
    // appliedTotal reads its data source. For the collection page it only registers
    // listeners and reads two nodes, none of which hydrate(), bind() or render() touch, so
    // running it earlier than before changes nothing.
    this.initDataSource();
    this.hydrate();
    this.bind();
    this.render();
    this.applyBtn.addEventListener('click', function () {
      return _this.apply();
    });
  }

  /**
   * Shopify data source: Section Rendering, the URL, and the vendor filter module.
   *
   * Moved verbatim out of the constructor so SearchFilterFlyout (search-filter-flyout.js)
   * can replace it wholesale with an InstantSearch source — see
   * docs/2026-09-11_search-filter-flyout-design.md §4.
   */
  return _createClass(FilterFlyout, [{
    key: "initDataSource",
    value: function initDataSource() {
      var _this2 = this;
      this.sectionId = this.root.dataset.ffSectionId;
      this.grid = document.querySelector('[data-products-grid]');
      window.addEventListener('popstate', function () {
        return _this2.onPopState();
      });

      // The vendor still owns the active-filter pills and the "Clear Filters" link in the
      // tools row (filters-active.liquid renders them as [data-filter-update-url] anchors,
      // handled at theme.dev.js:9159). Those change the URL and re-render the grid through
      // a path that knows nothing about this drawer, and they do NOT fire popstate — the
      // vendor pushes history itself. Without this the drawer's checkboxes stay ticked
      // after a "Clear Filters" click, disagreeing with both the URL and the grid.
      //
      // theme.dev.js:9279 dispatches this once the swap has landed. swapGrid dispatches it
      // too, so `applying` keeps our own apply from re-entering.
      document.addEventListener('theme:filters:applied', function () {
        if (_this2.applying) return;
        // syncFromUrl() re-requests the preview, which brings a fresh availability set with
        // it — the vendor widened or narrowed what is selectable and our classes still
        // describe the old filters. That used to need a second full-section fetch here.
        _this2.syncFromUrl();
      });

      // theme.dev.js:9004 binds a window popstate listener whenever the section has
      // [data-collection-sidebar] or [data-sort-enabled]. Both handlers would fetch and
      // write the grid on every Back/Forward. The vendor's restore is the better one —
      // it caches and aborts — so we defer the grid to it and only re-sync our own UI.
      var sectionEl = this.root.closest('.shopify-section');
      this.vendorHandlesHistory = Boolean(sectionEl && sectionEl.querySelector('[data-collection-sidebar], [data-sort-enabled]'));
    }

    // State always starts equal to the URL: read it off what Liquid marked checked.
  }, {
    key: "hydrate",
    value: function hydrate() {
      var _this3 = this;
      this.state.clear();
      this.panel.querySelectorAll('[data-ff-option] input:checked').forEach(function (input) {
        _this3.add(input.name, input.value);
      });
    }
  }, {
    key: "add",
    value: function add(name, value) {
      if (!this.state.has(name)) this.state.set(name, new Set());
      this.state.get(name).add(value);
    }
  }, {
    key: "remove",
    value: function remove(name, value) {
      var set = this.state.get(name);
      if (!set) return;
      set.delete(value);
      if (set.size === 0) this.state.delete(name);
    }
  }, {
    key: "total",
    get: function get() {
      var n = 0;
      this.state.forEach(function (set) {
        n += set.size;
      });
      return n;
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this4 = this;
      this.trigger.addEventListener('click', function () {
        return _this4.toggle();
      });
      this.scrim.addEventListener('click', function () {
        return _this4.close();
      });

      // Option changes update state only — no network (design decision 1).
      this.panel.addEventListener('change', function (event) {
        var input = event.target;
        if (!input.matches('[data-ff-option] input[type="checkbox"]')) return;
        if (input.checked) _this4.add(input.name, input.value);else _this4.remove(input.name, input.value);
        _this4.render();
        _this4.onStateChange();
      });
      this.rail.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-ff-tab]');
        if (tab) _this4.selectGroup(tab.dataset.ffTab);
      });
      this.closeBtn.addEventListener('click', function () {
        _this4.close();
        _this4.trigger.focus();
      });
      this.clearBtn.addEventListener('click', function () {
        _this4.state.clear();
        _this4.panel.querySelectorAll('[data-ff-option] input:checked').forEach(function (i) {
          i.checked = false;
        });
        _this4.render();
        // onStateChange re-requests the preview, which re-opens every option that the
        // now-cleared selection had hidden.
        _this4.onStateChange();
      });
      document.addEventListener('keydown', function (event) {
        if (_this4.panel.hidden) return;
        if (event.key === 'Escape') {
          _this4.close();
          _this4.trigger.focus();
          return;
        }
        if (event.key === 'Tab') {
          _this4.trapFocus(event);
          return;
        }

        // Arrow keys move between rail tabs — the tablist pattern.
        if (!event.target.matches('[data-ff-tab]')) return;
        // :not([hidden]) — the search flyout hides tabs whose facet has no values, and
        // arrowing onto one would reveal an empty panel. No collection tab is ever hidden.
        var tabs = _toConsumableArray(_this4.rail.querySelectorAll('[data-ff-tab]:not([hidden])'));
        var i = tabs.indexOf(event.target);
        var next = -1;
        if (event.key === 'ArrowDown') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === -1) return;
        event.preventDefault();
        _this4.selectGroup(tabs[next].dataset.ffTab);
        tabs[next].focus();
      });
    }

    /**
     * Tab trap for the open panel.
     *
     * The naive `button, input, [tabindex]` selector picks up descendants of hidden
     * tabpanels (`selectGroup` sets `group.hidden`) and options hidden by the in-group
     * (`selectGroup` sets `group.hidden`) — those are not focusable, so `.focus()` on one
     * silently no-ops and the trap fails open. It would also treat inactive rail
     * tabs (`tabindex="-1"`, set by `selectGroup`) as boundaries, which they must not be.
     * Excluding `[tabindex="-1"]` from every clause and filtering to elements that
     * currently have a layout box (`getClientRects().length > 0` — reliable under
     * `position: fixed`, unlike `offsetParent`) keeps the boundaries limited to what is
     * actually focusable right now.
     */
  }, {
    key: "trapFocus",
    value: function trapFocus(event) {
      var focusable = _toConsumableArray(this.panel.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])')).filter(function (el) {
        return el.getClientRects().length > 0;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }, {
    key: "onStateChange",
    value: function onStateChange() {
      // One request does both jobs — the count for the button, and the availability set
      // that hides options which would combine with the pending selection to yield nothing.
      this.requestPreview();
    }

    /**
     * Debounced, abortable preview of the pending selection.
     *
     * Fetches api-filter-count with the PENDING filters in the query string, which gets
     * back two things: how many results that selection would return, and every filter value
     * still selectable alongside it. Both are applied together, so the button and the option
     * list can never describe different states.
     *
     * Only ever one in flight: a newer request aborts the previous one, and a response from
     * a superseded request is discarded by sequence number. While in flight the button shows
     * no number rather than a stale one — but the option list is deliberately left alone
     * until the response lands, since blanking it would make the list flicker on every tick.
     */
  }, {
    key: "requestPreview",
    value: function requestPreview() {
      var _this5 = this;
      clearTimeout(this.countTimer);
      this.setApplyLabel(null);
      this.countTimer = setTimeout(function () {
        if (_this5.countController) _this5.countController.abort();
        _this5.countController = new AbortController();
        var seq = ++_this5.countSeq;
        var search = buildUrl(_this5.state, window.location.search);
        var joiner = search ? '&' : '?';
        var url = "".concat(window.location.pathname).concat(search).concat(joiner, "section_id=api-filter-count");
        fetch(url, {
          signal: _this5.countController.signal
        }).then(function (r) {
          return r.ok ? r.text() : Promise.reject(new Error(r.status));
        }).then(function (html) {
          // Section Rendering wraps every response in <div id="shopify-section-...">,
          // so this cannot be JSON. Read the data attributes out of the markup instead.
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-ff-count]');
          if (!el) throw new Error('no count element');
          return {
            doc: doc,
            count: parseInt(el.dataset.ffCount, 10),
            exact: el.dataset.ffExact === 'true'
          };
        }).then(function (data) {
          if (seq !== _this5.countSeq) return; // superseded
          _this5.setApplyLabel(data);
          _this5.applyAvailability(data.doc);
        }).catch(function () {
          // Aborted or failed — leave the neutral label and the option list as they are.
          // Never block, never stale, and never hide an option on a guess.
        });
      }, 300);
    }

    /**
     * Hide every option that would dead-end the pending selection.
     *
     * The payload is a flat array of [param_name, value] pairs — every value Shopify still
     * reports a non-zero count for once the pending filters are applied, plus the active
     * ones. Anything rendered but absent from it would produce no results in combination
     * with what is already ticked, so it goes.
     *
     * Toggles a class rather than the `hidden` attribute, which keeps availability legible
     * as its own state and leaves `hidden` free for anything that later needs to hide a row
     * for an unrelated reason.
     */
  }, {
    key: "applyAvailability",
    value: function applyAvailability(doc) {
      var source = doc.querySelector('[data-ff-available]');
      if (!source) return;
      var pairs;
      try {
        pairs = JSON.parse(source.textContent);
      } catch (error) {
        // Malformed payload. Leaving every option visible is the safe failure: a shopper
        // can recover from a dead-end filter, not from an option that was never offered.
        return;
      }
      this.markAvailable(new Set(pairs.map(function (pair) {
        return availabilityKey(pair[0], pair[1]);
      })));
    }

    /**
     * Toggle `is-unavailable` on every option whose availabilityKey() is not in `available`,
     * then refresh the per-group empty messages. The data-source-independent half of
     * applyAvailability(); SearchFilterFlyout feeds it from an Algolia preview instead.
     */
  }, {
    key: "markAvailable",
    value: function markAvailable(available) {
      this.panel.querySelectorAll('[data-ff-option]').forEach(function (li) {
        var input = li.querySelector('input[type="checkbox"]');
        if (!input) return;
        li.classList.toggle('is-unavailable', !available.has(availabilityKey(input.name, input.value)));
      });
      this.updateEmptyStates();
    }

    /**
     * Show the per-group "nothing left here" message when a group has no visible options.
     *
     * Driven off what is actually visible rather than off the cause, so it stays correct if
     * anything else ever hides options.
     */
  }, {
    key: "updateEmptyStates",
    value: function updateEmptyStates() {
      this.panel.querySelectorAll('[data-ff-group]').forEach(function (group) {
        var message = group.querySelector('[data-ff-empty]');
        if (!message) return;
        // querySelector, not querySelectorAll().length — it stops at the first hit, and the
        // Style group runs to ~100 options.
        message.hidden = Boolean(group.querySelector('[data-ff-option]:not(.is-unavailable):not([hidden])'));
      });
    }
  }, {
    key: "setApplyLabel",
    value: function setApplyLabel(data) {
      if (!data) {
        this.applyBtn.textContent = 'Show Results';
        return;
      }
      // Above 250 matches Liquid cannot count exactly — say so rather than lie.
      var n = data.exact ? "".concat(data.count) : "".concat(data.count, "+");
      this.applyBtn.textContent = "Show ".concat(n, " Results");
      if (this.status) this.status.textContent = "".concat(n, " results");
    }
  }, {
    key: "apply",
    value: function apply() {
      var _this6 = this;
      if (this.countController) this.countController.abort();
      clearTimeout(this.countTimer);
      var search = buildUrl(this.state, window.location.search);
      var target = "".concat(window.location.pathname).concat(search);
      var joiner = search ? '&' : '?';
      this.applyBtn.disabled = true;
      fetch("".concat(target).concat(joiner, "section_id=").concat(this.sectionId)).then(function (r) {
        return r.ok ? r.text() : Promise.reject(new Error(r.status));
      }).then(function (html) {
        // Mirrors the vendor's own guard — a response without the grid is a failure.
        if (html.indexOf('data-products-grid') === -1) throw new Error('no grid');
        // Push the URL BEFORE swapping the grid. collection.liquid:589's
        // renderCollectionPromos() reads location.search when it runs off the
        // theme:filters:applied event dispatched inside swapGrid — if the URL update
        // happened after, that listener would always see the pre-apply URL, both
        // over-injecting promo cards into a filtered grid and failing to restore them
        // when the last filter is cleared. The vendor does this same ordering itself
        // (theme.dev.js:9477-9479, addToHistory() before getFilterResult()).
        window.history.pushState({
          ff: true
        }, '', target);
        // swapGrid dispatches theme:filters:applied; this stops our own listener above
        // from treating our apply as a vendor-originated change and re-syncing over it.
        _this6.applying = true;
        _this6.swapGrid(html);
        _this6.applying = false;
        _this6.close();
      }).catch(function () {
        // Full navigation. The user still gets their filtered page.
        window.location.href = target;
      }).finally(function () {
        _this6.applyBtn.disabled = false;
      });
    }
  }, {
    key: "swapGrid",
    value: function swapGrid(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextGrid = doc.querySelector('[data-products-grid]');
      // Write into the existing node rather than replacing it (theme.dev.js:9250 does the
      // same) — the vendor's FiltersForm captures this node once in its constructor and
      // never re-queries it, so replaceWith would leave it holding a detached reference.
      if (nextGrid && this.grid) this.grid.innerHTML = nextGrid.innerHTML;
      this.syncOptionsFrom(doc);

      // Keep the hidden legacy sidebar in step, exactly as the vendor does in
      // applyFilterResponse (theme.dev.js:9242-9245).
      //
      // Not cosmetic — that sidebar holds the vendor's filter FORM, and addToHistory
      // (theme.dev.js:9190) rebuilds every filter.* param from `new FormData(this.form)`.
      // Leaving it stale means the next vendor-driven action rebuilds the URL from the
      // filters that were applied BEFORE our swap: changing the sort after a drawer apply
      // would silently revert the filters. It is also the rollback path, so it has to stay
      // truthful regardless.
      var nextSidebar = doc.querySelector('[data-collection-sidebar]');
      var liveSidebar = document.querySelector('[data-collection-sidebar]');
      if (nextSidebar && liveSidebar) liveSidebar.innerHTML = nextSidebar.innerHTML;

      // Rebuild the chips/badge/tab counts off the re-hydrated state, BEFORE the
      // count/status work below — the old chip buttons close over the `input` elements
      // that `liveOptions.innerHTML =` above just detached, so they must be remade
      // against the fresh ones.
      this.render();
      var nextCount = doc.querySelector('[data-active-filters-count]');
      var liveCount = document.querySelector('[data-active-filters-count]');
      if (nextCount && liveCount) liveCount.innerHTML = nextCount.innerHTML;

      // Keep the on-page product count and removable filter pills in step with the grid,
      // the same way the vendor does in applyFilterResponse (theme.dev.js:9243-9265) —
      // swapGrid only ever touched the grid itself, leaving both stale after an apply.
      var nextActiveFilters = doc.querySelector('[data-active-filters]');
      var liveActiveFilters = document.querySelector('[data-active-filters]');
      if (nextActiveFilters && liveActiveFilters) liveActiveFilters.innerHTML = nextActiveFilters.innerHTML;
      var nextProductsCount = doc.querySelector('[data-products-count]');
      var liveProductsCount = document.querySelector('[data-products-count]');
      if (nextProductsCount && liveProductsCount) liveProductsCount.innerHTML = nextProductsCount.innerHTML;

      // No "Showing N products" write to this.status here: updating [data-products-count]
      // above fires collection-filter-accessibility.js's own MutationObserver, which
      // announces that exact message itself. Writing it here too would double-announce,
      // so this apply path leaves [data-ff-status] alone — its only writer is the
      // count-settle announcement in setApplyLabel.

      // sections/collection.liquid:605 re-injects the promo cards on this event. The
      // vendor dispatches it after its own swap (theme.dev.js:9279); ours must too, or
      // the cards vanish until a hard reload.
      document.dispatchEvent(new CustomEvent('theme:filters:applied', {
        bubbles: true
      }));
    }

    /**
     * Re-derive the drawer's checked state from the URL.
     *
     * The single source of truth is the URL, so this is safe to call after ANY change we
     * did not originate — Back/Forward, or the vendor applying a filter through its own
     * path (the "Clear Filters" link and the removable pills in filters-active.liquid are
     * `[data-filter-update-url]` anchors handled at theme.dev.js:9159, which never touch
     * this drawer).
     */
    /**
     * Replace the options pane from a parsed collection-section response.
     *
     * Which values render at all is decided server-side from `filter_value.count`, so the
     * pane is stale the moment the applied filters change — clearing a filter widens what
     * is available, and nothing client-side can recompute that. The response carries a
     * correctly-rendered drawer, so take its options pane wholesale and re-derive state
     * from it.
     *
     * The in-group search term is deliberately not preserved: this only runs when the
     * applied filters changed, at which point the previous term is not meaningful.
     */
  }, {
    key: "syncOptionsFrom",
    value: function syncOptionsFrom(doc) {
      var nextOptions = doc.querySelector('[data-filter-flyout] .filter-flyout__options');
      var liveOptions = this.panel.querySelector('.filter-flyout__options');
      if (!nextOptions || !liveOptions) return;
      var activeTab = this.rail.querySelector('[aria-selected="true"]');
      var activeHandle = activeTab && activeTab.dataset.ffTab;
      liveOptions.innerHTML = nextOptions.innerHTML;
      this.hydrate();
      // The replacement markup arrives with server-seeded is-unavailable classes and every
      // empty message hidden, so a group that came back with nothing selectable needs its
      // message turned on here.
      this.updateEmptyStates();
      if (activeHandle) this.selectGroup(activeHandle);
    }
  }, {
    key: "syncFromUrl",
    value: function syncFromUrl() {
      var params = new URLSearchParams(window.location.search);
      this.panel.querySelectorAll('[data-ff-option] input').forEach(function (input) {
        input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
      });
      this.hydrate();
      this.render();

      // Re-derived state means whatever the apply button/live region showed is now stale
      // (it reflected the previous pending state's count) — reset the label and re-request
      // a correct one, and clear the live region so it doesn't repeat a now-wrong
      // announcement.
      //
      // Also re-derives which options are selectable, since the preview response carries
      // both. requestPreview() rather than onStateChange() only because the latter reads as
      // a user-initiated change; they do the same work.
      this.requestPreview();
      if (this.status) this.status.textContent = '';
    }
  }, {
    key: "onPopState",
    value: function onPopState() {
      var _this7 = this;
      this.syncFromUrl();

      // theme.dev.js:9004 already binds its own popstate listener whenever
      // [data-collection-sidebar] or [data-sort-enabled] is present (effectively always,
      // via collection-sorting.liquid) and restores the grid itself, with its own cache
      // and abort. Fetching the GRID here too would double-fetch and race it, so defer to
      // it. Our own option list is already handled: syncFromUrl() above re-requested the
      // preview, which the vendor never touches.
      if (this.vendorHandlesHistory) return;
      var search = window.location.search;
      var joiner = search ? '&' : '?';
      fetch("".concat(window.location.pathname).concat(search).concat(joiner, "section_id=").concat(this.sectionId)).then(function (r) {
        return r.ok ? r.text() : Promise.reject(new Error(r.status));
      }).then(function (html) {
        return _this7.swapGrid(html);
      }).catch(function () {
        return window.location.reload();
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.panel.hidden ? this.open() : this.close();
    }

    /**
     * Open the drawer.
     *
     * `hidden` is cleared first and `.is-open` added on the NEXT frame — adding both in
     * the same frame means the element goes from display:none straight to its final
     * transform, and the browser skips the transition entirely.
     */
  }, {
    key: "open",
    value: function open() {
      var _this8 = this;
      clearTimeout(this.closeTimer);
      this.panel.hidden = false;
      this.scrim.hidden = false;
      requestAnimationFrame(function () {
        _this8.panel.classList.add('is-open');
        _this8.scrim.classList.add('is-open');
      });
      this.trigger.setAttribute('aria-expanded', 'true');

      // Full-height fixed drawer at every width, so the page behind it must not scroll.
      // Reuse the theme's own lock (assets/theme.dev.js:530-531 listens on window for
      // these, bubbled from document) rather than inventing a second mechanism.
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
        bubbles: true,
        detail: this.panel
      }));
      var active = this.rail.querySelector('[aria-selected="true"]');
      if (active) active.focus();
    }

    /**
     * Close the drawer.
     *
     * `hidden` goes back on only after the slide-out finishes, so the panel animates off
     * instead of vanishing. A plain timer rather than `transitionend`: under
     * prefers-reduced-motion the transition is removed and that event never fires.
     */
  }, {
    key: "close",
    value: function close() {
      var _this9 = this;
      clearTimeout(this.countTimer);
      if (this.countController) this.countController.abort();
      this.panel.classList.remove('is-open');
      this.scrim.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
        bubbles: true
      }));
      this.closeTimer = setTimeout(function () {
        _this9.panel.hidden = true;
        _this9.scrim.hidden = true;
      }, CLOSE_MS);
    }
  }, {
    key: "selectGroup",
    value: function selectGroup(handle) {
      this.rail.querySelectorAll('[data-ff-tab]').forEach(function (tab) {
        var on = tab.dataset.ffTab === handle;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.panel.querySelectorAll('[data-ff-group]').forEach(function (group) {
        group.hidden = group.dataset.ffGroup !== handle;
      });
    }

    // Applied filter count, straight off the URL — one entry per active value, which is
    // exactly how the Liquid seeds the badge (`active_total` sums every filter's
    // active_values.size).
  }, {
    key: "appliedTotal",
    get: function get() {
      var n = 0;
      new URLSearchParams(window.location.search).forEach(function (value, key) {
        if (key.indexOf('filter.') !== 0) return;
        // Availability is asserted on every URL buildUrl() produces, not chosen by anyone —
        // counting it would leave the badge permanently reading one higher than the number of
        // filters the shopper can actually see or remove.
        if (key === AVAILABILITY_PARAM) return;
        n += 1;
      });
      return n;
    }
  }, {
    key: "render",
    value: function render() {
      var _this0 = this;
      // The badge counts APPLIED filters, not pending ones. It lives on the page rather
      // than in the drawer, describing the grid the shopper is actually looking at, so
      // ticking a box must not move it — only "Show Results" may, once the selection is in
      // the URL. Hence `appliedTotal` (URL) rather than `total` (the pending state Map).
      //
      // Every path that changes the URL ends here: apply() pushes the URL BEFORE swapGrid()
      // calls render(), and the vendor's own Clear/pill links and Back/Forward come through
      // syncFromUrl(). Clear inside the drawer deliberately does NOT move it — nothing has
      // been applied yet.
      var applied = this.appliedTotal;
      this.badge.textContent = applied;
      this.badge.hidden = applied === 0;

      // Selected state for the chip-grid layout (Size). It lives on the <li>, which is the
      // checkbox's PARENT — no sibling combinator reaches it, and `:has()` is used nowhere
      // else in this theme. render() is the right home: every path that can change a
      // checked state (change, clear, chip removal, hydrate-on-open, swapGrid, popstate)
      // ends here.
      this.panel.querySelectorAll('[data-ff-option]').forEach(function (li) {
        var input = li.querySelector('input[type="checkbox"]');
        li.classList.toggle('is-selected', Boolean(input && input.checked));
      });
      this.rail.querySelectorAll('[data-ff-tab]').forEach(function (tab) {
        var group = _this0.panel.querySelector("[data-ff-group=\"".concat(tab.dataset.ffTab, "\"]"));
        var n = group ? group.querySelectorAll('input:checked').length : 0;
        var countEl = tab.querySelector('[data-ff-tab-count]');
        countEl.textContent = n;
        countEl.hidden = n === 0;
      });
      this.chips.innerHTML = '';
      this.panel.querySelectorAll('[data-ff-option] input:checked').forEach(function (input) {
        var textEl = input.parentElement.querySelector('.filter-flyout__option-text');
        var label = (textEl || input.nextElementSibling).textContent.trim();
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'filter-flyout__chip';

        // Label and the ✕ are separate spans so the glyph can be styled (and dimmed)
        // independently. aria-hidden on the ✕: the whole chip is the remove control and
        // already carries the "Remove Colour Blue" name set below, so announcing a
        // multiplication sign inside it would only repeat the affordance badly.
        var chipLabel = document.createElement('span');
        chipLabel.className = 'filter-flyout__chip-label';
        chipLabel.textContent = label;
        chip.appendChild(chipLabel);
        var chipX = document.createElement('span');
        chipX.className = 'filter-flyout__chip-x';
        chipX.setAttribute('aria-hidden', 'true');
        chipX.textContent = '✕';
        chip.appendChild(chipX);
        // "Remove M" is ambiguous across Size and Style, so name the group too. The
        // visible chip text stays bare — only the accessible name is qualified.
        var group = input.closest('[data-ff-group]');
        var tab = group && _this0.rail.querySelector("[data-ff-tab=\"".concat(group.dataset.ffGroup, "\"]"));
        var groupName = tab ? tab.firstElementChild.textContent.trim() : '';
        chip.setAttribute('aria-label', groupName ? "Remove ".concat(groupName, " ").concat(label) : "Remove ".concat(label));
        chip.addEventListener('click', function () {
          input.checked = false;
          _this0.remove(input.name, input.value);
          _this0.render();
          _this0.onStateChange();
        });
        _this0.chips.appendChild(chip);
      });
    }
  }]);
}();

;// ./src/js/components/search-filter-helpers.js
function search_filter_helpers_typeof(o) { "@babel/helpers - typeof"; return search_filter_helpers_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, search_filter_helpers_typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = search_filter_helpers_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function search_filter_helpers_toPropertyKey(t) { var i = search_filter_helpers_toPrimitive(t, "string"); return "symbol" == search_filter_helpers_typeof(i) ? i : i + ""; }
function search_filter_helpers_toPrimitive(t, r) { if ("object" != search_filter_helpers_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != search_filter_helpers_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function search_filter_helpers_toConsumableArray(r) { return search_filter_helpers_arrayWithoutHoles(r) || search_filter_helpers_iterableToArray(r) || search_filter_helpers_unsupportedIterableToArray(r) || search_filter_helpers_nonIterableSpread(); }
function search_filter_helpers_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function search_filter_helpers_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return search_filter_helpers_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? search_filter_helpers_arrayLikeToArray(r, a) : void 0; } }
function search_filter_helpers_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function search_filter_helpers_arrayWithoutHoles(r) { if (Array.isArray(r)) return search_filter_helpers_arrayLikeToArray(r); }
function search_filter_helpers_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Pure helpers for the search-page filter flyout (search-filter-flyout.js).
 *
 * No DOM and no InstantSearch — plain data in, plain data out — so they run under
 * `node --test tests/search-filter-helpers.test.mjs`.
 *
 * Filter state everywhere is the shape FilterFlyout already uses:
 *   Map<attribute, Set<value>>, e.g. Map { 'options.size' => Set { 'S', 'M' } }
 */


// Asserted whenever at least one filter is applied; never shown, never counted.
// Spec decision 4.
var IN_STOCK_FILTER = 'inventory_available:true';
var SIZE_ATTRIBUTE = 'options.size';

// Enough for every value any group has today — Style runs to ~100 on shop-all, and denim
// alone has 72 colours on production. Algolia's ceiling is 1000. Must match `limit` on the
// virtual refinement widgets in snippets/footer-scripts.liquid.
var MAX_VALUES_PER_FACET = 500;

// A leading '-' makes Algolia read a facet filter as a negation.
function escapeFacetValue(value) {
  return value.charAt(0) === '-' ? "\\".concat(value) : value;
}

/** State -> Algolia facetFilters. OR within a group (inner array), AND across groups. */
function toFacetFilters(state) {
  var out = [];
  state.forEach(function (values, attribute) {
    var group = [];
    values.forEach(function (value) {
      return group.push("".concat(attribute, ":").concat(escapeFacetValue(value)));
    });
    if (group.length) out.push(group);
  });
  return out;
}

/** State -> InstantSearch uiState.refinementList: { attribute: [values] }. */
function toRefinementList(state) {
  var out = {};
  state.forEach(function (values, attribute) {
    if (values.size) out[attribute] = search_filter_helpers_toConsumableArray(values);
  });
  return out;
}

/** InstantSearch uiState.refinementList -> state. Empty groups are dropped. */
function stateFromRefinementList(refinementList) {
  var state = new Map();
  Object.keys(refinementList || {}).forEach(function (attribute) {
    var values = refinementList[attribute] || [];
    if (values.length) state.set(attribute, new Set(values));
  });
  return state;
}

/** Number of applied values across every group. */
function countRefinements(refinementList) {
  return Object.keys(refinementList || {}).reduce(function (n, attribute) {
    return n + (refinementList[attribute] || []).length;
  }, 0);
}

/**
 * The preview for a PENDING selection, as one multi-query (spec §5.3).
 *
 * - requests[countIndex].nbHits is the "Show N Results" number. In-stock applies to it only
 *   when something is selected — zero filters means today's unfiltered results.
 * - facetSources says which request's facets decide availability for which groups. Those
 *   requests ALWAYS carry in-stock: the first tick turns in-stock on, so a value that only
 *   exists out of stock must not be offered.
 * - Groups with a selection get their own request that leaves that group out, so values in
 *   the same group stay selectable (OR within, AND across — disjunctive faceting).
 * - With a selection, the count request is also the availability request for every
 *   unselected group (same filters, same in-stock), so it is sent once, not twice.
 *
 * @param {Object} args
 * @param {string} args.indexName
 * @param {string} args.query
 * @param {Map<string, Set<string>>} args.state
 * @param {string[]} args.attributes  The groups currently offered, in rail order.
 * @param {boolean} [args.alwaysInStock]  The section's "Hide out-of-stock products" setting.
 *   When on, the count request carries in-stock too, so "Show N Results" can't promise more
 *   than the grid will show.
 * @returns {Object} `{ requests, countIndex, facetSources }` — requests: Array of
 *   `{ indexName, params }`; countIndex: number; facetSources: Array of `{ index, attributes }`.
 */
function buildPreviewRequests(_ref) {
  var indexName = _ref.indexName,
    query = _ref.query,
    state = _ref.state,
    attributes = _ref.attributes,
    alwaysInStock = _ref.alwaysInStock;
  var base = {
    query: query,
    hitsPerPage: 0,
    // Previews are not searches a shopper ran. Keep them out of Algolia analytics and away
    // from the queryID the hits template stores for click tracking (spec decision 10).
    analytics: false,
    clickAnalytics: false,
    maxValuesPerFacet: MAX_VALUES_PER_FACET
  };
  var hasSelection = state.size > 0;
  var unselected = attributes.filter(function (attribute) {
    return !state.has(attribute);
  });
  var selected = attributes.filter(function (attribute) {
    return state.has(attribute);
  });
  var requests = [];
  var facetSources = [];
  requests.push({
    indexName: indexName,
    params: _objectSpread(_objectSpread({}, base), {}, {
      facetFilters: toFacetFilters(state),
      filters: alwaysInStock || hasSelection ? IN_STOCK_FILTER : '',
      facets: hasSelection ? unselected : []
    })
  });
  if (hasSelection) {
    if (unselected.length) facetSources.push({
      index: 0,
      attributes: unselected
    });
  } else if (unselected.length) {
    requests.push({
      indexName: indexName,
      params: _objectSpread(_objectSpread({}, base), {}, {
        facetFilters: [],
        filters: IN_STOCK_FILTER,
        facets: unselected
      })
    });
    facetSources.push({
      index: requests.length - 1,
      attributes: unselected
    });
  }
  selected.forEach(function (attribute) {
    var others = new Map(state);
    others.delete(attribute);
    requests.push({
      indexName: indexName,
      params: _objectSpread(_objectSpread({}, base), {}, {
        facetFilters: toFacetFilters(others),
        filters: IN_STOCK_FILTER,
        facets: [attribute]
      })
    });
    facetSources.push({
      index: requests.length - 1,
      attributes: [attribute]
    });
  });
  return {
    requests: requests,
    countIndex: 0,
    facetSources: facetSources
  };
}

/**
 * Multi-query results -> the Set of availabilityKey()s still selectable, for
 * FilterFlyout#markAvailable.
 *
 * A ticked value is ALWAYS available — the same guard as the collection's `value.active` —
 * so an applied filter can never hide itself and become unremovable.
 */
function collectAvailable(results, facetSources, state) {
  var available = new Set();
  facetSources.forEach(function (_ref2) {
    var index = _ref2.index,
      attributes = _ref2.attributes;
    var facets = results[index] && results[index].facets || {};
    attributes.forEach(function (attribute) {
      var counts = facets[attribute] || {};
      Object.keys(counts).forEach(function (value) {
        if (counts[value] > 0) available.add(availabilityKey(attribute, value));
      });
    });
  });
  state.forEach(function (values, attribute) {
    values.forEach(function (value) {
      return available.add(availabilityKey(attribute, value));
    });
  });
  return available;
}
var LETTER_SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
function sizeRank(value) {
  var letter = LETTER_SIZES.indexOf(value.toUpperCase());
  if (letter !== -1) return [0, letter];
  // '00' is smaller than '0' in women's sizing but parses to the same number.
  if (/^\d+$/.test(value)) return [1, value === '00' ? -1 : parseInt(value, 10)];
  return [2, 0];
}

/**
 * Wear order: letters XXS→XXL, then numbers numerically (00, 0, 2 … 32), then anything
 * else alphabetically. Client-side because Algolia's facetOrdering differs between the two
 * apps and sorts numbers as strings (spec decision 9). Returns a new array.
 */
function sortSizes(values) {
  return search_filter_helpers_toConsumableArray(values).sort(function (a, b) {
    var ra = sizeRank(a);
    var rb = sizeRank(b);
    return ra[0] - rb[0] || ra[1] - rb[1] || a.localeCompare(b);
  });
}
;// ./src/js/components/search-filter-flyout.js
function search_filter_flyout_typeof(o) { "@babel/helpers - typeof"; return search_filter_flyout_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, search_filter_flyout_typeof(o); }
function search_filter_flyout_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function search_filter_flyout_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? search_filter_flyout_ownKeys(Object(t), !0).forEach(function (r) { search_filter_flyout_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : search_filter_flyout_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function search_filter_flyout_defineProperty(e, r, t) { return (r = search_filter_flyout_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function search_filter_flyout_toConsumableArray(r) { return search_filter_flyout_arrayWithoutHoles(r) || search_filter_flyout_iterableToArray(r) || search_filter_flyout_unsupportedIterableToArray(r) || search_filter_flyout_nonIterableSpread(); }
function search_filter_flyout_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function search_filter_flyout_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return search_filter_flyout_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? search_filter_flyout_arrayLikeToArray(r, a) : void 0; } }
function search_filter_flyout_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function search_filter_flyout_arrayWithoutHoles(r) { if (Array.isArray(r)) return search_filter_flyout_arrayLikeToArray(r); }
function search_filter_flyout_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function search_filter_flyout_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function search_filter_flyout_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, search_filter_flyout_toPropertyKey(o.key), o); } }
function search_filter_flyout_createClass(e, r, t) { return r && search_filter_flyout_defineProperties(e.prototype, r), t && search_filter_flyout_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function search_filter_flyout_toPropertyKey(t) { var i = search_filter_flyout_toPrimitive(t, "string"); return "symbol" == search_filter_flyout_typeof(i) ? i : i + ""; }
function search_filter_flyout_toPrimitive(t, r) { if ("object" != search_filter_flyout_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != search_filter_flyout_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == search_filter_flyout_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Search-page filter flyout.
 *
 * The collection flyout's UI — open/close, rail, keyboard, focus trap, chips, pending
 * state — with an Algolia data source in place of Shopify's. Only data methods are
 * overridden; docs/2026-09-11_search-filter-flyout-design.md §2.2 lists the split.
 *
 * InstantSearch's uiState is the single source of truth for what is APPLIED. The inherited
 * `this.state` Map holds what is PENDING. Nothing touches the URL (spec decision 3).
 *
 * NO CLASS FIELDS in this file. The base constructor calls initDataSource() and render()
 * from inside super(), and class fields are assigned only after super() returns — so a
 * field declared here would silently overwrite what initDataSource() set.
 */


var SearchFilterFlyout = /*#__PURE__*/function (_FilterFlyout) {
  /**
   * @param {Element|null} root    The [data-search-filter-flyout] element.
   * @param {Object} bridge        window.FESearch — `{ search, searchClient, indexName }` —
   *   set by the InstantSearch setup in snippets/footer-scripts.liquid.
   */
  function SearchFilterFlyout(root, bridge) {
    search_filter_flyout_classCallCheck(this, SearchFilterFlyout);
    return _callSuper(this, SearchFilterFlyout, [root, {
      bridge: bridge
    }]);
  }
  _inherits(SearchFilterFlyout, _FilterFlyout);
  return search_filter_flyout_createClass(SearchFilterFlyout, [{
    key: "initDataSource",
    value: function initDataSource() {
      var _this = this;
      var _this$options$bridge = this.options.bridge,
        search = _this$options$bridge.search,
        searchClient = _this$options$bridge.searchClient,
        indexName = _this$options$bridge.indexName,
        alwaysInStock = _this$options$bridge.alwaysInStock;
      this.search = search;
      this.searchClient = searchClient;
      this.indexName = indexName;
      // The section's "Hide out-of-stock products" setting. When on, `configure` owns the
      // in-stock filter for the whole page and commit() must not touch it.
      this.alwaysInStock = !!alwaysInStock;
      this.universeQuery = null;
      this.previewSeq = 0;
      this.announcePending = false;
      this.resultsAtCommit = null;
      this.pills = document.querySelector('[data-search-active-filters]');
      this.pillIcon = document.querySelector('[data-search-pill-icon]');
      this.search.on('render', function () {
        return _this.onSearchRender();
      });
      // Results may already have landed if this bundle ran late.
      this.onSearchRender();
    }

    /** Applied refinements, straight off InstantSearch: { attribute: [values] }. */
  }, {
    key: "appliedRefinements",
    value: function appliedRefinements() {
      var uiState = this.search.getUiState()[this.indexName] || {};
      return uiState.refinementList || {};
    }

    // The badge counts APPLIED filters. In-stock lives in `configure`, not refinementList,
    // so it can never inflate this.
  }, {
    key: "appliedTotal",
    get: function get() {
      return countRefinements(this.appliedRefinements());
    }
  }, {
    key: "onSearchRender",
    value: function onSearchRender() {
      // 'idle' means results have landed; renders also fire on the way into loading.
      if (this.search.status !== 'idle') return;
      var results = this.search.helper && this.search.helper.lastResults;
      if (!results) return;

      // The full option set can only be read off an UNFILTERED result: a filtered one narrows
      // every other group to values compatible with the filter, so unticking in the drawer
      // would have nothing to bring back. Filters never reach the URL, so every page load's
      // first render is unfiltered (spec §5.2). Re-read if the query changes while nothing is
      // applied — the custom search box refines from '' to the URL's term on load.
      if (this.appliedTotal === 0 && results.query !== this.universeQuery) {
        this.universeQuery = results.query;
        this.buildOptions();
      }

      // While the drawer is open its checkboxes are the PENDING selection — leave them.
      if (this.panel.hidden) this.syncFromApplied();
      this.render();
      this.renderPills();
      if (this.announcePending && results !== this.resultsAtCommit) {
        this.announcePending = false;
        this.announceResults(results.nbHits);
      }
    }

    /**
     * Render every value of every group as a checkbox row, show only the tabs that have
     * values, and select the first. Hides the trigger when no group has anything — the
     * collection's "no filters, no drawer" rule (collection-filter-flyout.liquid).
     */
  }, {
    key: "buildOptions",
    value: function buildOptions() {
      var _this2 = this;
      var lists = (this.search.renderState[this.indexName] || {}).refinementList || {};
      var firstVisible = null;
      this.panel.querySelectorAll('[data-ff-group]').forEach(function (group) {
        var attribute = group.dataset.ffAttribute;
        var handle = group.dataset.ffGroup;
        var tab = _this2.rail.querySelector("[data-ff-tab=\"".concat(handle, "\"]"));
        var list = group.querySelector('.filter-flyout__list');
        if (!lists[attribute]) {
          // No widget mounted for this attribute, so setUiState() could never apply it.
          // Loud here rather than a filter that silently does nothing.
          console.error("[search-filter-flyout] no refinement widget for \"".concat(attribute, "\" \u2014 add it to flyoutAttributes in snippets/footer-scripts.liquid."));
        }
        var values = (lists[attribute] && lists[attribute].items || []).map(function (item) {
          return item.value;
        });
        if (attribute === SIZE_ATTRIBUTE) values = sortSizes(values);
        list.textContent = '';
        values.forEach(function (value, i) {
          return list.appendChild(_this2.createOption(attribute, handle, value, i));
        });
        if (tab) tab.hidden = values.length === 0;
        if (values.length && !firstVisible) firstVisible = handle;
      });
      this.trigger.hidden = !firstVisible;
      if (firstVisible) this.selectGroup(firstVisible);
      this.hydrate();
      this.updateEmptyStates();
    }

    /**
     * One option row — the same markup snippets/collection-filter-flyout.liquid renders, so
     * the inherited render(), chips and styles work unchanged. Built with DOM calls, never
     * innerHTML: the values come from the search index.
     */
  }, {
    key: "createOption",
    value: function createOption(attribute, handle, value, index) {
      var id = "ff-".concat(handle, "-").concat(index + 1);
      var li = document.createElement('li');
      li.className = 'filter-flyout__option';
      li.setAttribute('data-ff-option', '');
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.className = 'filter-flyout__option-input';
      input.id = id;
      input.name = attribute;
      input.value = value;
      var label = document.createElement('label');
      label.className = 'filter-flyout__option-label';
      label.htmlFor = id;
      var text = document.createElement('span');
      text.className = 'filter-flyout__option-text';
      text.textContent = value;
      label.appendChild(text);
      li.appendChild(input);
      li.appendChild(label);
      return li;
    }

    /** Checkboxes := applied state. The search counterpart of the base class's syncFromUrl(). */
  }, {
    key: "syncFromApplied",
    value: function syncFromApplied() {
      var applied = this.appliedRefinements();
      this.panel.querySelectorAll('[data-ff-option] input').forEach(function (input) {
        input.checked = (applied[input.name] || []).indexOf(input.value) !== -1;
      });
      this.hydrate();
    }
  }, {
    key: "open",
    value: function open() {
      _superPropGet(SearchFilterFlyout, "open", this, 3)([]);
      // Availability has to be computed with in-stock on before anything is ticked: the first
      // tick turns in-stock on, so a value that only exists out of stock would dead-end. The
      // collection gets this from server-rendered counts; search asks Algolia.
      this.requestPreview();
    }

    /**
     * Count + dead-end hiding for the PENDING selection, in one Algolia round trip.
     *
     * Same debounce, supersession and failure behaviour as the base class's Shopify preview;
     * the request plan itself is buildPreviewRequests() (spec §5.3). algoliasearch-lite takes
     * no AbortSignal, so a superseded response is dropped by sequence number instead.
     */
  }, {
    key: "requestPreview",
    value: function requestPreview() {
      var _this3 = this;
      clearTimeout(this.countTimer);
      this.setApplyLabel(null);
      this.countTimer = setTimeout(function () {
        var seq = ++_this3.previewSeq;
        var plan = buildPreviewRequests({
          indexName: _this3.indexName,
          // always the primary index — sort never changes counts
          query: _this3.search.helper.state.query || '',
          state: _this3.state,
          attributes: _this3.visibleAttributes(),
          alwaysInStock: _this3.alwaysInStock
        });
        _this3.searchClient.search(plan.requests).then(function (_ref) {
          var results = _ref.results;
          if (seq !== _this3.previewSeq) return; // superseded, applied, or the drawer closed
          // distinct is on in both Algolia apps, so nbHits counts products, exactly.
          _this3.setApplyLabel({
            count: results[plan.countIndex].nbHits,
            exact: true
          });
          _this3.markAvailable(collectAvailable(results, plan.facetSources, _this3.state));
        }).catch(function () {
          // Leave the neutral label and the option list as they are. Never block, never
          // stale, and never hide an option on a guess.
        });
      }, 300);
    }

    /** Attributes of the tabs currently offered, in rail order. Hidden groups are never queried. */
  }, {
    key: "visibleAttributes",
    value: function visibleAttributes() {
      var _this4 = this;
      return search_filter_flyout_toConsumableArray(this.panel.querySelectorAll('[data-ff-group]')).filter(function (group) {
        var tab = _this4.rail.querySelector("[data-ff-tab=\"".concat(group.dataset.ffGroup, "\"]"));
        return tab && !tab.hidden;
      }).map(function (group) {
        return group.dataset.ffAttribute;
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.previewSeq += 1; // a preview landing after close must not repaint the panel
      _superPropGet(SearchFilterFlyout, "close", this, 3)([]);
    }
  }, {
    key: "apply",
    value: function apply() {
      clearTimeout(this.countTimer);
      this.previewSeq += 1; // discard any preview still in flight
      this.commit(this.state);
      this.close();
    }

    /**
     * Make `state` the APPLIED filters. The only writer of InstantSearch filter state — Apply,
     * the pills and Clear all come through here — so in-stock can never be on with nothing
     * applied, or off with something applied.
     *
     * `filters` is always set, to '' when nothing is applied, rather than relying on an
     * empty `configure` object to clear the previous value.
     *
     * Unless `alwaysInStock` is on — then footer-scripts.liquid mounts `configure` WITH the
     * filter, so it applies from first paint rather than only after the first commit, and
     * writing `filters` here would be dead weight (configure's own params win over uiState's).
     */
  }, {
    key: "commit",
    value: function commit(state) {
      var _this5 = this;
      var refinementList = toRefinementList(state);
      this.announcePending = true; // announced by onSearchRender once the results land
      this.resultsAtCommit = this.search.helper && this.search.helper.lastResults;
      this.search.setUiState(function (uiState) {
        var current = uiState[_this5.indexName] || {};
        var configure = _this5.alwaysInStock ? current.configure : search_filter_flyout_objectSpread(search_filter_flyout_objectSpread({}, current.configure), {}, {
          filters: Object.keys(refinementList).length ? IN_STOCK_FILTER : ''
        });
        return search_filter_flyout_objectSpread(search_filter_flyout_objectSpread({}, uiState), {}, search_filter_flyout_defineProperty({}, _this5.indexName, search_filter_flyout_objectSpread(search_filter_flyout_objectSpread({}, current), {}, {
          // keeps query and sortBy
          refinementList: refinementList,
          configure: configure,
          page: undefined
        })));
      });
    }

    /**
     * The removable pills under the tools bar, from APPLIED state — the search counterpart of
     * snippets/filters-active.liquid. Same classes, so the collection styles apply. Buttons,
     * not links: there is no URL to link to.
     *
     * Removing one applies immediately, as on the collection page, through commit() — so
     * removing the last filter also drops in-stock.
     */
  }, {
    key: "renderPills",
    value: function renderPills() {
      var _this6 = this;
      if (!this.pills) return;
      var applied = this.appliedRefinements();
      this.pills.textContent = '';

      // Rail order, not uiState order, so the pills read in the same order as the tabs.
      this.panel.querySelectorAll('[data-ff-group]').forEach(function (group) {
        var attribute = group.dataset.ffAttribute;
        var groupName = _this6.groupLabel(group);
        (applied[attribute] || []).forEach(function (value) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'active__filters__remove';
          // Qualified by group because "Remove M" is ambiguous between Size and Style,
          // matching the drawer's own chips.
          pill.setAttribute('aria-label', "Remove ".concat(groupName, " ").concat(value));
          pill.appendChild(document.createTextNode(value));
          var x = document.createElement('span');
          x.className = 'filter__x';
          if (_this6.pillIcon) x.appendChild(_this6.pillIcon.content.cloneNode(true));
          pill.appendChild(x);
          pill.addEventListener('click', function () {
            var next = stateFromRefinementList(_this6.appliedRefinements());
            if (next.has(attribute)) {
              next.get(attribute).delete(value);
              if (next.get(attribute).size === 0) next.delete(attribute);
            }
            _this6.commit(next);
            // The pill is about to be re-rendered away; don't strand focus on <body>.
            _this6.trigger.focus();
          });
          _this6.pills.appendChild(pill);
        });
      });

      // Only once there is more than one thing to clear, as filters-active.liquid does.
      if (this.appliedTotal > 1) {
        var clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'active__filters__clear';
        clear.textContent = this.pills.dataset.clearLabel;
        clear.addEventListener('click', function () {
          _this6.commit(new Map());
          _this6.trigger.focus();
        });
        this.pills.appendChild(clear);
      }
    }

    /** The visible tab name for a group, e.g. "Size". */
  }, {
    key: "groupLabel",
    value: function groupLabel(group) {
      var tab = this.rail.querySelector("[data-ff-tab=\"".concat(group.dataset.ffGroup, "\"]"));
      return tab ? tab.firstElementChild.textContent.trim() : '';
    }

    /**
     * "2 filters applied. Showing 58 products." — the message the collection page gets from
     * collection-filter-accessibility.js, which never initialises on search (it needs
     * .filter__button checkboxes). Written once per commit to the flyout's own live region.
     */
  }, {
    key: "announceResults",
    value: function announceResults(count) {
      if (!this.status) return;
      var filters = this.appliedTotal;
      var message = '';
      if (filters > 0) message = "".concat(filters, " ").concat(filters === 1 ? 'filter' : 'filters', " applied. ");
      message += "Showing ".concat(count, " ").concat(count === 1 ? 'product' : 'products', ".");
      this.status.textContent = message;
    }
  }]);
}(FilterFlyout);

;// ./src/entries/page-search.js


// window.FESearch is set by the inline InstantSearch setup in snippets/footer-scripts.liquid,
// inside its DOMContentLoaded handler. This bundle is deferred, so it normally runs first and
// waits for the event; the direct check covers the reverse order.
function init() {
  if (!window.FESearch) return false;
  new SearchFilterFlyout(document.querySelector('[data-search-filter-flyout]'), window.FESearch);
  return true;
}
if (!init()) document.addEventListener('fe:search:ready', init, {
  once: true
});
/******/ })()
;